export default __webpack_public_path__ + "static/media/airbnb-button.0c42a596.png";